import type { IBasketItem } from '../context/BasketStore'

export const needsPartRecovery = (item: IBasketItem): boolean => {
  const product = item.colourWay
  return product._id === product.productCatalogueId
    && product.components?.length === 1
    && Boolean(product.components[0].componentVariantId?.$oid)
    && Boolean(product.components[0].chosenMaterial?.$oid)
}

export const partRecoveryKey = (items: IBasketItem[]): string => JSON.stringify(
  items.filter(needsPartRecovery).map(item => [item.id, item.colourWay])
)

// Match the saved choice, never a catalogue default or merely a similar name.
export const findRecoveryPart = (item: IBasketItem, candidates: any[]): any | null => {
  if (!needsPartRecovery(item)) return null
  const selected = item.colourWay.components![0]
  const matches = candidates.filter(part => {
    if (part.type !== 'part' || part._id === item.colourWay._id
      || part.productCatalogueId !== item.colourWay.productCatalogueId
      || part.isAvailableForSale !== true || part.productRemoval
      || part.components?.length !== 1) return false
    const component = part.components[0]
    const materials = [...(component.materialOptions || []), component.defaultMaterial]
    return (component.defaultVariant === selected.componentVariantId.$oid)
      && (component.quantity ?? 1) === 1
      && materials.includes(selected.chosenMaterial.$oid)
  })
  return matches.length === 1 ? matches[0] : null
}
